import React from 'react';
import { Separator } from "@/components/ui/separator";

interface SectionHeadingProps {
  title: string;
  description?: string;
  className?: string;
  align?: "left" | "center";
}

export function SectionHeading({ 
  title, 
  description, 
  className = "",
  align = "left" 
}: SectionHeadingProps) {
  return (
    <div className={`mb-8 ${className}`}>
      <h2 className={`text-2xl font-serif font-medium text-gray-900 mb-2 ${align === "center" ? "text-center" : ""}`}>
        {title}
      </h2>
      <Separator className="mb-4 bg-indigo-900/30" />
      
      {description && (
        <p className={`text-sm text-gray-700 mt-4 ${align === "center" ? "text-center" : ""}`}>
          {description}
        </p>
      )}
    </div>
  );
}